(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      document.dispatchEvent(new CustomEvent('motivelle:close-mega'));

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals =
        this.searchModals ||
        this.header.querySelectorAll('details-modal');

      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  function initMotivelleMegaMenus(root = document) {
    const headers = root.querySelectorAll('[data-motivelle-header]');

    headers.forEach((wrapper) => {
      if (wrapper.dataset.motivelleMegaInitialized === 'true') {
        return;
      }

      const panel = wrapper.querySelector('[data-motivelle-mega]');
      const triggers = Array.from(wrapper.querySelectorAll('[data-mega-trigger]'));
      const contents = Array.from(wrapper.querySelectorAll('[data-mega-content]'));
      const closeLinks = Array.from(wrapper.querySelectorAll('[data-mega-close-link]'));

      if (!panel || !triggers.length || !contents.length) {
        return;
      }

      wrapper.dataset.motivelleMegaInitialized = 'true';

      const desktopMedia = window.matchMedia('(min-width: 990px)');

      let activeKey = null;
      let activeTrigger = null;
      let closeTimer = null;

      const cancelClose = () => {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
        }

        closeTimer = null;
      };

      const closeMega = () => {
        cancelClose();

        activeKey = null;

        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');

        wrapper.classList.remove('motivelle-mega-open');

        triggers.forEach((trigger) => {
          trigger.classList.remove('is-active');
          trigger.setAttribute('aria-expanded', 'false');
        });

        contents.forEach((content) => {
          content.classList.remove('is-active');
          content.setAttribute('aria-hidden', 'true');
        });
      };

      const openMega = (key, trigger) => {
        if (!desktopMedia.matches) return;

        cancelClose();

        activeKey = key;
        activeTrigger = trigger;

        triggers.forEach((item) => {
          const active = item.dataset.megaTrigger === key;

          item.classList.toggle('is-active', active);

          item.setAttribute(
            'aria-expanded',
            active ? 'true' : 'false'
          );
        });

        contents.forEach((content) => {
          const active = content.dataset.megaContent === key;

          content.classList.toggle('is-active', active);

          content.setAttribute(
            'aria-hidden',
            active ? 'false' : 'true'
          );
        });

        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');

        wrapper.classList.add('motivelle-mega-open');
      };

      const scheduleClose = (delay = 140) => {
        cancelClose();

        closeTimer = window.setTimeout(closeMega, delay);
      };

      triggers.forEach((trigger) => {
        const key = trigger.dataset.megaTrigger;

        trigger.addEventListener('mouseenter', () => {
          openMega(key, trigger);
        });

        trigger.addEventListener('focus', () => {
          openMega(key, trigger);
        });

        trigger.addEventListener('click', () => {
          if (!desktopMedia.matches) return;

          if (
            activeKey === key &&
            panel.classList.contains('is-open')
          ) {
            closeMega();
          } else {
            openMega(key, trigger);
          }
        });

        trigger.addEventListener('keydown', (event) => {
          if (
            !desktopMedia.matches ||
            event.key !== 'ArrowDown'
          ) {
            return;
          }

          event.preventDefault();

          openMega(key, trigger);

          const content = contents.find(
            (item) => item.dataset.megaContent === key
          );

          const firstLink = content
            ? content.querySelector('a[href]')
            : null;

          if (firstLink) {
            firstLink.focus();
          }
        });
      });

      closeLinks.forEach((link) => {
        link.addEventListener('mouseenter', () => scheduleClose(80));
        link.addEventListener('focus', () => scheduleClose(80));
      });

      wrapper.addEventListener('mouseenter', cancelClose);
      wrapper.addEventListener('mouseleave', () => scheduleClose(140));

      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', () => scheduleClose(140));

      wrapper.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!wrapper.contains(document.activeElement)) {
            closeMega();
          }
        }, 0);
      });

      document.addEventListener('motivelle:close-mega', closeMega);

      document.addEventListener('keydown', (event) => {
        if (
          event.key !== 'Escape' ||
          !panel.classList.contains('is-open')
        ) {
          return;
        }

        const triggerToFocus = activeTrigger;

        closeMega();

        if (triggerToFocus) {
          triggerToFocus.focus();
        }
      });

      document.addEventListener('pointerdown', (event) => {
        if (!wrapper.contains(event.target)) {
          closeMega();
        }
      });

      desktopMedia.addEventListener('change', closeMega);
    });
  }

  document.addEventListener(
    'open',
    (event) => {
      if (
        !(event.target instanceof HTMLElement) ||
        !event.target.matches('shopify-account')
      ) {
        return;
      }

      document.dispatchEvent(new CustomEvent('motivelle:close-mega'));

      const bottom = Math.max(
        0,
        Math.round(
          event.target.getBoundingClientRect().bottom
        )
      );

      event.target.style.setProperty(
        '--account-dialog-top',
        `${bottom}px`
      );
    },
    true
  );

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initMotivelleMegaMenus(document),
      {
        once: true
      }
    );
  } else {
    initMotivelleMegaMenus(document);
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initMotivelleMegaMenus(event.target);
    }
  );

  } catch(e) { console.error(e); }
})();
})();
